import { styled, Button as _Button, ButtonProps, CircularProgress, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useState } from 'react';
import ConfirmationDialog from './ConfirmationDialog';

type CustomButtonProps = ButtonProps & {
  height?: string;
  loading?: boolean;
  onClick?: () => void;
  mustConfirm?: boolean;
  mustConfirmContent?: string;
};

const DEFAULT_BUTTON_HEIGHT = 48;
const DEFAULT_BUTTON_BORDER_RADIUS = '28px';

const useStyles = makeStyles(({ palette }: Theme) => ({
  contained: {
    background: palette.primary.main,
    borderRadius: `${DEFAULT_BUTTON_BORDER_RADIUS} !important`,
  },

  text: {},

  outlined: {},
}));

const StyledButton = styled(_Button)(({ height, color, theme }: CustomButtonProps & { theme: Theme }) => ({
  color: color || theme.palette.neutral[600],
  height: height || `${DEFAULT_BUTTON_HEIGHT}px`,
}));

export const Button = ({
  variant,
  loading,
  children,
  disabled,
  onClick,
  mustConfirmContent = 'Deseja continuar esta operação?',
  mustConfirm = false,
  ...props
}: CustomButtonProps): JSX.Element => {
  const styles = useStyles();

  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  const handleSubmit = () => {
    if (mustConfirm) {
      setDialogOpen(true);
      return;
    }
    if (onClick) {
      onClick();
    }
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleAccept = () => {
    if (onClick) {
      onClick();
    }
    setDialogOpen(false);
  };

  const defaultVariant = variant || 'contained';

  return (
    <>
      <StyledButton
        {...props}
        disabled={disabled || loading}
        className={`${styles[defaultVariant]} ${props.className}`}
        variant={defaultVariant}
        onClick={() => handleSubmit()}
      >
        {loading ? <CircularProgress color="secondary" size={DEFAULT_BUTTON_HEIGHT - 20} /> : children}
      </StyledButton>
      <ConfirmationDialog
        open={dialogOpen}
        content={mustConfirmContent}
        onClose={handleCloseDialog}
        onCancel={handleCloseDialog}
        onAccept={handleAccept}
      />
    </>
  );
};

export default Button;
